import './App.css';
import Main from './Layouts/Main/Main'

function App() {
  return (
    <div className="app">
      <Main />
    </div>
  );
}

export default App;
